module.exports = __webpack_public_path__ + "2620c8c2/img/rename-icon.de4e673d.svg";